export default __webpack_public_path__ + "static/plotnine-small-15b8b22cf40b6b5f096f9ca4b5bbd8ba.png";